import { envDomain } from '@/common/contact-selector/utils/domainConfig';
import convertList from '../convertList';
import filters from '../filters';
import sign from '../sign';

function searchQQFriendByName(params) {
    const currentParams = {
        name: params.name
    };
    if (params.pageInfo) {
        currentParams.index = params.pageInfo.index;
        currentParams.count = params.pageInfo.size;
        currentParams.privateRemark = 1;
    }
    return Vue.prototype.$_sAjax.crossGet(`${envDomain.gateway}/v1/qq/searchQQFriends`, {
        params: currentParams
    });
}

export default function(params) {
    return new Promise((resolve, reject) => {
        searchQQFriendByName(params).then(
            res => {
                if (window.parseInt(res.code) === 0 && res.data && res.data.friends) {
                    // const oneWayUins = window.QD_QQFRIEND_ONEWAYUINS || [];
                    const oneWayUins = [];
                    res.data.friends.forEach(element => {
                        if (element.isOneWayFriend) {
                            oneWayUins.push(element.uin);
                        }
                    });
                    let newList = convertList(res.data.friends);
                    newList = newList.map(originItem => {
                        const item = originItem;
                        // 私有备注优先级最高
                        item.name = item.privateRemark || item.name;
                        return item;
                    });
                    // 为单向关系链的联系人数据打标记
                    console.log(newList, oneWayUins);
                    newList = sign.oneWayRelationshipChain(newList, 'QQFriend', {
                        oneWayUins,
                        ...params
                    });
                    filters.setKfuinTypeInList(newList).then(resList => {
                        resolve({
                            list: resList,
                            params: {
                                index: res.data.index,
                                end: res.data.isEnd
                            }
                        });
                    });
                } else {
                    reject(res);
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
